<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15WM3mm/images/9780316243933.jpg?1732296862340" alt="This image is the cover for the book Good People"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Good People
      </h1>
      <p class="bookDescription body article font2">
        <b>From the author of <i>Burial Rites</i>, "a literary novel with the pace and tension of a thriller that takes us on a frightening journey towards an unspeakable tragedy" (Paula Hawkins, bestselling author of <i>The Girl on the Train</i> and <i>Into the Water</i>).</b><br/><br/> Based on true events in nineteenth century Ireland, Hannah Kent's startling new novel tells the story of three women, drawn together to rescue a child from a superstitious community. <br/><br/> Nora, bereft after the death of her husband, finds herself alone and caring for her grandson Micheal, who can neither speak nor walk. A handmaid, Mary, arrives to help Nora just as rumors begin to spread that Micheal is a changeling child who is bringing bad luck to the valley. Determined to banish evil, Nora and Mary enlist the help of Nance, an elderly wanderer who understands the magic of the old ways. <br/><br/> Set in a lost world bound by its own laws, <i>The Good People</i> is Hannah Kent's startling new novel about absolute belief and devoted love. Terrifying, thrilling and moving in equal measure, this follow-up to Burial Rites shows an author at the height of her powers.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hannah Kent
      </h2>
      
      <p class="authorDescription body article"><B>Hannah Kent</B> was born in Adelaide in 1985. Her first novel, Burial Rites, has been translated into nearly thirty languages and was shortlisted for the Baileys Women's Prize for Fiction (formerly the Orange Prize), the <I>Guardian</I> First Book Award and the International IMPAC Dublin Literary Award. Hannah is also the co-founder and publishing director of Australian literary journal <I>Kill Your Darlings</I>. <I>The Good People</I> is her second novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fda2301a